import { LAYOUT_CONSTANTS } from "@/_self_managed/LAYOUT_CONSTANTS";
import { colors2 } from "oolib";
import React from "react";

export const SystemComsTextBox = ({children, style={}}) => {
  return (
    <div
      style={{
        padding: LAYOUT_CONSTANTS.pagePadding + "px",
        // background: colors2.yellowBG,
        background: 'linear-gradient(118.55deg,#9dffea50 -18.66%,#bdd4ff50 52.78%,#ffc9f050 122.8%)',
        boxShadow: `-2px -2px 8px ${colors2.grey5} inset`,
        // border: `1px solid ${colors2.yellowStroke}`,
        // color: colors2.yellow,
        borderRadius: '6px',
        ...style
      }}
    >
        {children}
    </div>
  );
};
